module.exports = __webpack_public_path__ + "img/docs.9e4a1ca5.svg";